import { useEffect, useState } from 'react';

const STORAGE_KEY = 'agendaqx_theme'; // 'light' | 'dark'

const prefiereOscuroDelSistema = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

const obtenerThemeInicial = () => {
  try {
    const guardado = localStorage.getItem(STORAGE_KEY);
    if (guardado === 'light' || guardado === 'dark') return guardado;
  } catch { /* localStorage no disponible (modo privado, etc.) */ }
  return prefiereOscuroDelSistema() ? 'dark' : 'light';
};

/**
 * Hook de modo claro/oscuro para toda la aplicación.
 * - Persiste la preferencia en localStorage.
 * - Si el usuario nunca eligió manualmente, respeta prefers-color-scheme.
 * - Aplica/retira la clase `.dark` en <html>, de la que dependen tanto
 *   global.css como los estilos ya preparados en src/reservacion/styles
 *   (footer.css, header.css, reservar.css ya tienen reglas .dark).
 */
const useTheme = () => {
  const [theme, setTheme] = useState(obtenerThemeInicial);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* noop */ }
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return { theme, toggleTheme, esOscuro: theme === 'dark' };
};

export default useTheme;
